import 'styles/main.styl'
import 'utils/loadAsyncSVG'
import React from 'react'
import { GIT_VERSION } from 'gatsby-env-variables'
import isClient from 'utils/isClient'
import makeSetup from 'utils/make/setup'

if (isClient()) {
  window.__VERSION__ = GIT_VERSION
}

Promise.resolve(
  import(
    /* webpackChunkName: "thirdPartyScripts" */ './utils/thirdPartyScripts.js'
  )
)

makeSetup()

function wrapElement({ element }) {
  return <>{element}</>
}

export default wrapElement
